enum PersonTypeEnum {
  PHYSICAL = 'PHYSICAL',
  LEGAL = 'LEGAL',
}

export { PersonTypeEnum };
